import { I18nPluralPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, linkedSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideCircleX } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { ExpansionPanel } from '@shared/components/expansion-panel/expansion-panel.component';
import { ToastrSuccessComponent } from '@shared/components/toastr/toastr-success.component';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmSwitchImports } from '@spartan-ng/helm/switch';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { RégionStore } from '../../../administration/gestion-sites/store/région.store';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { Étape } from '../../../référentiel-métier-parcours/models/étape.model';
import { ÉTAT_GROUPE } from '../../enum/état-groupe.enum';
import { Groupe } from '../../models/groupe.model';
import { ConvertEtatGroupeToStringPipe } from '../../pipes/convert-etat-groupe-to-string.pipe';
import { ConvertIdsReferentielsToNomsPipe } from '../../pipes/convert-ids-referentiels-to-noms.pipe';
import { GetEtatGroupeVariantPipe } from '../../pipes/get-etat-groupe-variant.pipe';
import { GroupeStore } from '../../store/groupe.store';
import { ResumeEtapeComponent } from '../resume-etape/resume-etape.component';

@Component({
  selector: 'app-list-groupes',
  imports: [
    ResumeEtapeComponent,
    ExpansionPanel,
    I18nPluralPipe,
    HlmSwitchImports,
    ChipComponent,
    ConvertEtatGroupeToStringPipe,
    GetEtatGroupeVariantPipe,
    FormsModule,
    HlmIconImports,
    HlmButtonImports,
    HlmLabelImports,
    NgTemplateOutlet,
    ConvertIdsReferentielsToNomsPipe,
  ],
  templateUrl: './list-groupes.component.html',
  providers: [provideIcons({ lucideCircleX, lucideCircleCheck })],
})
export class ListGroupesComponent {
  readonly #régionStore = inject(RégionStore);
  readonly #groupeStore = inject(GroupeStore);

  readonly cartographie = input.required<Cartographie>();
  readonly etape = input.required<Étape>();

  readonly groupes = linkedSignal(() => this.etape().groupes ?? []);

  readonly etatGroupe = ÉTAT_GROUPE;

  protected readonly anneeMapping: { [k: string]: string } = {
    '=1': '#ère année',
    other: '#ème année',
  };

  modifierEtatGroupe(groupe: Groupe, état: ÉTAT_GROUPE) {
    const toastrId = uuidv7();

    this.#groupeStore.modifier({
      id: groupe.id,
      data: { ...groupe, etat: état },
      next: () => {
        this.#régionStore.charger(this.cartographie().id);
        this.groupes.update((groupes) =>
          groupes.map((x) => {
            if (groupe.id !== x.id) return x;

            x.etat = état;
            return x;
          }),
        );
        toast.custom(ToastrSuccessComponent, {
          componentProps: {
            message: `Groupe correctement envoyé à validation`,
            id: toastrId,
          },
          id: toastrId,
        });
      },
    });
  }
}
